//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import bankInfo from '@/components/BankInfo'
import payMethod from '@/components/Repay/PayMethod'
import chooseCard from '@/components/ChooseCard'
import CustomChecker from "@/components/CustomChecker";
import { getThemeByType, getStorage, setStorage, getBizType } from '@/js/utils'
export default {
    name: 'pay',
    components: {
        // bankInfo,
        payMethod,
        chooseCard,
        CustomChecker
    },
    created() {
        // if (
        //     window.PPDWebUI &&
        //     window.PPDWebUI.os.inApp &&
        //     ['PPDLoanApp'].includes(window.PPDWebUI.os.channel)
        // ) {
        //     window.PPDWebUI.CommonService.setNavigation(
        //         {
        //             visible: '1',
        //             fullScreen: '2',
        //             leftView: [
        //                 {
        //                     action: 'back',
        //                     icon: 'ppdwebui://resource/drawable/nav_back'
        //                 }
        //             ]
        //         },
        //         function () { },
        //         function (err) { }
        //     )
        // }

        const { appId, bizCode, orderNo, businessID } = this.$store
        this.isLoanApp =
            window.PPDWebUI &&
            window.PPDWebUI.os.inApp &&
            window.PPDWebUI.os.channel === 'PPDLoanApp'

        // if (this.isLoanApp) {
        //     const [
        //         version,
        //         firstVer,
        //         secondVer,
        //         thirdVer
        //     ] = PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/)
        //     // 借款版本大于等于7.16.0才能支持微信支付
        //     this.isWechatValid =
        //         parseInt(
        //             firstVer + secondVer.padStart(2, '0') + thirdVer.padStart(2, '0')
        //         ) >= 71600

        //     // 借款版本大于等于8.4.0才能支持支付宝支付
        //     this.isAlipayValid =
        //         parseInt(
        //             firstVer + secondVer.padStart(2, '0') + thirdVer.padStart(2, '0')
        //         ) >= 80400
        // }

        this.showTheLoading(async () => {
            const data = await this.doRequest('chargeLoad', { orderNum: orderNo })

            const { themeType, bankCardList, sourceTitle, paymentMethods } = data

            this.payInitData = data

            this.bankInfo = bankCardList && bankCardList.length ? bankCardList[0] : {}
            this.currentChoosedCard = this.bankInfo.userBankAccountId
            this.themeType = getThemeByType(themeType || '0')

            this.$bus.$emit('update-title', {
                hasHeader: sourceTitle
            })

            this.isCardSupport =
                paymentMethods.includes(2) && bankCardList && bankCardList.length
            // this.isWechatSupport = this.isWechatValid && paymentMethods.includes(3)
            // this.isAlipaySupport = this.isAlipayValid && paymentMethods.includes(7)

            if (this.isCardSupport) {
                this.payMethod = 'card'
            } else if (this.isWechatSupport) {
                this.payMethod = 'wechat'
            } else if (this.isAlipaySupport) {
                this.payMethod = 'alipay'
            } else {
            }

            this.sensorsRecord("h5_element_imp", {
                tgt_event_id: "h5_paycash_pay_pageview",
                tgt_name: "h5-paycash-支付页-页面曝光",
                url: location.href,
                page: "支付页",
            });
        }, 'isLoading')
    },
    data() {
        return {
            payMethod: 'card',
            bankInfo: {},
            currentChoosedCard: '',
            showPop: false,
            isBtnDisabled: false,
            isLoading: false,
            payInitData: {}
        }
    },
    computed: {
        payMethods() {
            let methods = []

            if (this.isCardSupport) {
                methods.push('card')
            }

            // if (this.isWechatSupport) {
            //     methods.push('wechat')
            // }

            // if (this.isAlipaySupport) {
            //     methods.push('alipay')
            // }

            return methods
        },
    },
    methods: {
        goToChooseCard() {
            this.showPop = true
        },
        chooseMethod({ type, bankInfo }) {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_pay_choosemethod",
                tgt_name: "h5-paycash-支付页-选择支付方式",
                url: location.href,
                page: "支付页",
                param4: type
            });
            if (type === 'card') {
                this.payMethod = type
                this.bankInfo = bankInfo
                this.currentChoosedCard = this.bankInfo.userBankAccountId
            }
            // if (['wechat', 'alipay'].includes(type)) {
            //     this.currentChoosedCard = ''
            //     this.payMethod = type
            // }
            this.showPop = false
        },
        deleteCard(userBankAccountId) {
            const vm = this
            this.$vux.confirm.show({
                title: '提示',
                content: '确认要删除这张银行卡吗',
                async onConfirm() {
                    const { data } = await vm.$http.unbind({
                        orderNum: vm.$store.orderNo,
                        userBankAccountId
                    })
                    if (data) {
                        if (getBizType() === 'Koo') {
                            location.replace(data.url);
                        } else {
                            location.href = data.url
                        }
                    }
                }
            })

            const bankList = this.payInitData.bankCardList
            const idx = bankList.findIndex(
                item => item.userBankAccountId === userBankAccountId
            )
            bankList.splice(idx, 1)

            // 如果删的是当前卡，那么选择一张卡作为默认卡
            if (this.bankInfo.userBankAccountId === userBankAccountId) {
                this.bankInfo =
                    bankList.find(item =>
                        item.singleLimit
                            ? +item.singleLimit > +this.payInitData.amount
                            : true
                    ) || {}
                this.currentChoosedCard = this.bankInfo.userBankAccountId
            }

            this.showPop = false
        },
        async addCard() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_pay_addcard",
                tgt_name: "h5-paycash-支付页-添加银行卡",
                url: location.href,
                page: "支付页",
            });
            const data = await this.doRequest('chargeAddCard', {
                orderNum: this.$store.orderNo
            })
            if (getBizType() === 'Koo') {
                location.replace(data.url);
            } else {
                location.href = data.url
            }
            // location.href = data.url
        },
        async changeCard() {
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_pay_changecard",
                tgt_name: "h5-paycash-支付页-修改银行卡",
                url: location.href,
                page: "支付页",
            });
            const data = await this.doRequest('chargeChangeCard', {
                orderNum: this.$store.orderNo,
                userBankAccountId: this.bankInfo.userBankAccountId
            })
            if (getBizType() === 'Koo') {
                location.replace(data.url);
            } else {
                location.href = data.url
            }
            // location.href = data.url
        },
        showWechatError(message) {
            this.$vux.toast.show({
                type: 'text',
                text: message,
                width: '50%'
            })
        },
        clearTimer() {
            clearInterval(this.queryTimer)
            clearTimeout(this.timer)
        },
        payResultProcessing() {
            return new Promise(resolve => {
                const seconds = this.payInitData.processingSeconds
                    ? this.payInitData.processingSeconds * 1000
                    : 10000
                this.queryPayResult(resolve)
                this.timer = setTimeout(() => {
                    this.clearTimer()
                    if (this.statusCode !== 2) {
                        resolve()
                    }
                }, seconds)
                this.queryTimer = setInterval(() => {
                    this.queryPayResult(resolve)
                }, 3000)
            })
        },
        async queryPayResult(resolve) {
            const data = await this.doRequest('chargeQueryResult', {
                payOrderNum: getStorage('session', 'payOrderNum')
            })
            this.statusCode = data.statusCode
            if (data.statusCode === 2) {
                this.clearTimer()
                this.jumpToResultPage()
                resolve()
            }
        },
        nextStep() {
            this.showTheLoading(async () => {
                this.isBtnDisabled = true
                let paymentMethod = 2

                // if (this.payMethod === 'wechat') {
                //     paymentMethod = 3
                // } else if (this.payMethod === 'alipay') {
                //     paymentMethod = 7
                // }

                this.sensorsRecord("h5_clk", {
                    tgt_event_id: "h5_paycash_pay_confirm",
                    tgt_name: "h5-paycash-支付页-确认支付",
                    url: location.href,
                    page: "支付页",
                    param4: paymentMethod
                });
                try {
                    const data = await this.doRequest('createCharge', {
                        appSourceType: 1,
                        orderNum: this.$store.orderNo,
                        payType: 1,
                        paymentMethod,
                        userBankAccountId: this.currentChoosedCard,
                        wxOpenId: ''
                    })

                    this.sensorsRecord("h5_clk", {
                        tgt_event_id: "h5_paycash_pay_createcharge",
                        tgt_name: "h5-paycash-支付页-创建订单",
                        url: location.href,
                        page: "支付页",
                        param4: data.payOrderNum
                    });

                    setStorage('session', 'payOrderNum', data.payOrderNum)

                    await new Promise(resolve => {
                        this.resolve = resolve
                        if (
                            ['wechat', 'alipay'].includes(this.payMethod) &&
                            this.isLoanApp &&
                            !this.isMountListener
                        ) {
                            this.isMountListener = true
                            PPDWebUI.ListenerService.resumeListener(async () => {
                                // 支付中断查询支付结果
                                await this.payResultProcessing()
                                this.resolve()
                            })
                        }

                        if (this.payMethod === 'wechat') {
                            if (!PPDWebUI.PayService || !PPDWebUI.PayService.wxPay) {
                                PPDWebUI.registerNewService('PayService', 'wxPay')
                            }

                            PPDWebUI.PayService.wxPay(
                                { authCode: data.resultParam },
                                data => {
                                    if (data.status === '20') {
                                        this.jumpToResultPage()
                                    } else {
                                        this.showWechatError('支付失败')
                                    }
                                    resolve()
                                },
                                e => {
                                    this.showWechatError(e.message)
                                    resolve()
                                }
                            )
                        } else if (this.payMethod === 'alipay') {
                            const info = JSON.parse(data.resultParam)

                            if (this.isLoanApp) {
                                if (!PPDWebUI.PayService || !PPDWebUI.PayService.aliPay) {
                                    PPDWebUI.registerNewService('PayService', 'aliPay')
                                }

                                PPDWebUI.PayService.aliPay(
                                    { authCode: info.authCode },
                                    data => {
                                        if (data.resultStatus === '9000') {
                                            this.jumpToResultPage()
                                        } else {
                                            this.showWechatError('支付失败')
                                        }
                                        resolve()
                                    },
                                    e => {
                                        this.showWechatError(e.message)
                                        resolve()
                                    }
                                )
                            }
                        } else {
                            resolve()
                            this.jumpToResultPage()
                        }
                    })
                } catch (error) {
                    this.jumpToResultPage()
                }

                this.isBtnDisabled = false
            })

        },
        jumpToResultPage() {
            const {
                repayResultPageTag,
                orderType,
                multiCard,
                amount,
                processingSeconds
            } = this.payInitData

            // 结果页时使用的参数
            setStorage('session', 'payResultParams', {
                isShowResult: repayResultPageTag,
                themeType: this.themeType,
                multiCard,
                processingSeconds,
                repayAmount: amount,
                payMethod: this.payMethod
            })

            this.$router.replace({
                name: 'payResult',
                query: {
                    type: 'pay-result-processing',
                    orderNo: this.$store.orderNo,
                    returnUrl: this.payInitData.returnUrl
                }
            })

            // if (
            //     !repayResultPageTag &&
            //     ['wechat', 'alipay'].includes(this.payMethod)
            // ) {
            //     const returnUrl = this.payInitData.returnUrl

            //     location.replace(
            //         `${returnUrl}${returnUrl.indexOf('?') !== -1 ? '&' : '?'
            //         }status=1&message=成功`
            //     )
            // } else {
            //     this.$router.replace({
            //         name: 'payResult',
            //         query: {
            //             type: ['wechat', 'alipay'].includes(this.payMethod)
            //                 ? 'pay-result-success'
            //                 : 'pay-result-processing',
            //             orderNo: this.$store.orderNo,
            //             returnUrl: this.payInitData.returnUrl
            //         }
            //     })
            // }
        }
    }
}
